import React, { Component } from 'react'
import { FaBookmark, FaRegBookmark } from "react-icons/fa6";

export default class Bookmark extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isBookmarked: this.props.value,
        }
    }

    render() {
        return (
            <div className='bookmark-question' onClick={() => {
                this.setState({
                    isBookmarked: !this.state.isBookmarked,
                })
                this.props.handleBookmarkClick()
            }}>
                {this.state.isBookmarked ?
                    <FaBookmark fontSize={22} fontWeight={100} color='#ebc351' />
                    : <FaRegBookmark fontSize={22} fontWeight={100} color='#666' />
                }

            </div>
        )
    }
}
